var _defs, _rect, _g, _line;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a-editicon{fill:rgba(255,124,124,0);}.b-editicon{fill:#484848;}.c-editicon{fill:none;stroke:#484848;}\n\t\t"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a-editicon",
    width: 16,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.33 -1075.008) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-editicon",
    d: "M13721,22203h3l-1.5,1.5Zm0,0v-8h3v8Z",
    transform: "translate(-12858 -21532)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b-editicon",
    width: 3,
    height: 1,
    transform: "translate(863 661)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c-editicon",
    x2: 9,
    transform: "translate(3.5 13.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.1143ca203bb4364351f63a4cffd75d29.svg";
export { ForwardRef as ReactComponent };